import { useLocalization, useUrl } from '@shopify/hydrogen'
import { CountryCode, LanguageCode } from '@shopify/hydrogen/storefront-api-types'
import styles from '../../assets/scss/components/language/language-switch.module.scss'
import { useI18n } from '../i18n.client'

export const LanguageSwitchLink: React.FC<{
  code: string
  countryCode: CountryCode
  languageCode: LanguageCode
  title: string
}> = ({ code, countryCode, languageCode, title }) => {
  const {
    language: { isoCode: language },
    country: { isoCode: country },
  } = useLocalization()

  const [i18n] = useI18n()
  const { pathname } = useUrl()
  const regex = /^\/([a-z]{2})(-([a-z]{2}))?(\/|$)/i
  const sanitisedPathname = pathname.replace(regex, '/')

  if (country === countryCode && language === languageCode) {
    return <span className={styles.active}>{i18n.translate(title)}</span>
  }

  return <a href={`/${code}${sanitisedPathname}`}>{i18n.translate(title)}</a>
}
